import { Company } from "../gateway/Company/Company";
import { UserDataAdapter } from "../presentation/adpters/UserDataAdapter";
import { GetCompaniesByIdsAndFilterUsecase } from "./get-companies-by-ids-and-filter.usecase";

export class PopulateCompaniesAuditUsecase {
    constructor() {
        this.CompanyGateway = new Company();
    }

    async execute({
        accountingId,
        filters = {},
        rules,
        insightsFastAccess,
        source,
        lastAvailable,
        date
    } = {}) {
        const user = new UserDataAdapter().user();
        console.time("COMPANIES_POPULATE");
        let response = [];
        if (user.roles.includes("Empresa")) {
            const companyIds = user.profile?.companyIds;
            const getCompaniesByIdsAndFilterUsecase = new GetCompaniesByIdsAndFilterUsecase();
            const companies = await getCompaniesByIdsAndFilterUsecase.execute({
                companyIds,
                entity: true,
                filters
            });
            response = this.getCompaniesWithInsightRules(
                companies,
                date,
                rules,
                insightsFastAccess,
                source,
                lastAvailable
            );
        } else {
            const companiesAccounting = await this.CompanyGateway.getByAccountingId(
                {
                    accountingId,
                    withContacts: false,
                    summary: true,
                    user,
                    ...filters
                }
            );

            response = this.getCompaniesWithInsightRules(
                companiesAccounting,
                date,
                rules,
                insightsFastAccess,
                source,
                lastAvailable
            );
        }
        this.CompanyGateway.deleteMany({ accountingId });
        const hasResponse = response.length;

        if (hasResponse) this.CompanyGateway.createMany(response, accountingId);
        console.timeEnd("COMPANIES_POPULATE");
        return hasResponse ? true : false;
    }

    getCompaniesWithInsightRules(
        companies,
        date,
        rules,
        insightsFastAccess,
        source,
        lastAvailable
    ) {
        const companiesEntities = companies.map((companyEntity) => {
            if (rules.length) {
                companyEntity.setInsightRule({
                    rules,
                    insightsFastAccess,
                    source,
                    date,
                    lastAvailable
                });
            }

            return companyEntity;
        });

        return companiesEntities;
    }
}
